import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";
import { iconPositionClass, sizeBtn } from "./constant";

export type Props = ComponentProps<"button"> & {
  label?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  iconPosition?: "left" | "right";
  isLoading?: boolean;
  size: "xLarge" | "large" | "medium" | "small";
};

export const HeaderButton = ({
  className,
  size = "xLarge",
  label,
  icon,
  children,
  iconPosition = "left",
  ...props
}: Props) => {
  return (
    <button
      {...props}
      className={twMerge(
        `border border-[#3064c0] text-[#3064c0]`,
        `hover:border-[#2C5BAF] hover:text-[#2c5baf]`,
        `active:border-[#224788] border  active:text-[#224788] active:bg-[#EAF0F9]`,
        `disabled:border-disable border  disabled:text-disable`,
        sizeBtn[size],
        iconPositionClass[iconPosition],
        " align-center flex font-medium text-xs leading-4  items-center gap-1 justify-center rounded-md",
        className
      )}
    >
      <>
        {label && <span>{label}</span>}
        {icon}
        {children}
      </>
    </button>
  );
};
